import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface CustomParamsDialogData {
	resource_link_id: string;
	context_id: string;
	user_id: string;
}

@Component({
	selector: 'app-custom-params-dialog',
	templateUrl: './custom-params-dialog.component.html',
	styleUrls: ['./custom-params-dialog.component.scss'],
	standalone: false
})
export class CustomParamsDialogComponent {

	public constructor (
		public dialogRef: MatDialogRef<CustomParamsDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: CustomParamsDialogData
	) {}

	public close () {
		this.dialogRef.close();
	}
}
